import { styled } from "@mui/material";

export const PoweredBy = styled("span")(() => ({
  fontSize: "14px",
  letterSpacing: "0.25px",
  lineHeight: "20px",
  fontFamily: "Manrope",
  color: "#344054",
}));

export const ButtonImage = styled("div")(() => ({
  cursor: "pointer",
  gap: "12px",
  display: "flex",
}));

export const FooterContainer = styled("div", {
  shouldForwardProp: (props) => props !== "center",
})(({ center }: { center?: boolean }) => ({
  backgroundColor: "#FFFFFF",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: center ? "center" : "flex-start",
  padding: "16px 32px",
  width: "100%",
}));

export const Logo = styled("img")(() => ({
  width: "118px",
  height: "24px",
}));
